webpackJsonp([55],{

/***/ "H4F6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-invoice-history-table_168e75b0bfaafa93f628ab1f8b0feb42.html";

/***/ }),

/***/ "c6SK":
/***/ (function(module, exports, __webpack_require__) {

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var SubscriptionInvoiceHistoryTable = (function () {
    function SubscriptionInvoiceHistoryTable() {
        this.invoicesList = this.invoicesList.map(function (invoice) {
            var isSuccess = ['SUCCESS', 'REFUNDED'].includes(invoice.status);
            var status = isSuccess ? invoice.status.toLowerCase() : 'fail';
            var errorMessage = isSuccess ? '' : invoice.status;
            return __assign({}, invoice, { status: status,
                errorMessage: errorMessage });
        });
    }
    SubscriptionInvoiceHistoryTable.prototype.getInvoiceUrl = function (invoiceId) {
        return options.apiDomain + "/subscription/invoice/" + invoiceId;
    };
    return SubscriptionInvoiceHistoryTable;
}());
angular
    .module('animatronApp.SubscriptionInvoiceHistoryTable', [])
    .component('subscriptionInvoiceHistoryTable', {
    bindings: {
        invoicesList: '<'
    },
    controller: SubscriptionInvoiceHistoryTable,
    templateUrl: __webpack_require__("H4F6")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/55-40ecf89b893baa28ab63.min.js